module.exports = __webpack_public_path__ + "static/media/icons-24-redirect.229e91b7.svg";